import styled from "styled-components";
import { format } from "date-fns";
import { FlightDetail, MilestoneState, MileStoneUpdateOfOceanState } from "./types/MilestoneType";
import { convertToInputDateFormat } from "./dateUtils";

export const getMinDateTime = () => {
  const now = new Date();
  const offset = now.getTimezoneOffset();
  const local = new Date(now.getTime() - offset * 60 * 1000);
  return local.toISOString().slice(0, 16);
};



// Format: 8/05/2025, 20:14
export const formatDateTime = (dateString: any) => {
  if (!dateString) return "N/A";
  // if (dateString == "N/A") return dateString;
  return format(new Date(dateString), "d/MM/yyyy, HH:mm");
};

// Format: 8/05/2025
export const formatDateOnly = (dateString: any) => {
  if (!dateString) return "";
  return format(new Date(dateString), "d/MM/yyyy");
};



export const toDateTimeLocal = (isoString: string) => {
  if (!isoString) return "";
  const d = new Date(isoString);
  const off = d.getTimezoneOffset();
  const local = new Date(d.getTime() - off * 60 * 1000);
  return local.toISOString().slice(0, 16); // keep YYYY-MM-DDTHH:mm
};


export const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});




export function mapToMilestoneState(
  trackData: any,
  awbNumber: string,
  isOnline: boolean
): MilestoneState[] {

  let flateData = (trackData?.events || []).flat();
  let { pieces, weight } = trackData;

  // STEP 1: MAP BASIC DATA
  let mappedData = flateData.map((event: any, index: number) => ({
    _id: event._id,
    awbNumber,
    mileStoneSequence: index + 1,
    mileStone: event.milestone,
    date: event.date || "",
    estimatedDate: event?.estimatedDate || "",
    flightNumber: event.flightNumber || undefined,
    origin: event.origin || "",
    destination: event.destination || "",
    station: event.station || "",
    isDetailAwaitedForPartShipment: event?.isDetailAwaitedForPartShipment || false,
    pieces: event.pieces ?? pieces,
    weight: event.weight ?? weight,
    status: event.status,
    isPart: event.isPart || false,
    totalPieces: event.totalPieces || event.pieces,
    totalWts: event.totalWts || event.weight,
    flights: event?.flights || [],
    allFlights: event?.allFlights || [],
  }));
  if (isOnline) return mappedData;


  // -----------------------------
  // STEP 2: FIRST PASS (DEPARTURE PART)
  // -----------------------------
  let seq = 1;
  let result: MilestoneState[] = [];

  for (let i = 0; i < mappedData.length; i++) {
    let cur = mappedData[i];
    cur.mileStoneSequence = seq++;

    result.push(cur);

    if (cur.isDetailAwaitedForPartShipment && cur.isPart === true) {
     let flightNumber=cur.flights.filter((ele: any) => !cur.allFlights.includes(ele.flightNumber))[0]?.flightNumber||""
      let partMiles = {
        ...cur,
        pieces: pieces - cur.totalPieces,
        weight: weight - cur.totalWts,
        status: 0,
        date: "",
        estimatedDate: "",
        _id: "",
        isPart: true,
        isDetailAwaitedForPartShipment: true,
        mileStoneSequence: seq++,
        flights: cur.flights.filter((ele: any) => !cur.allFlights.includes(ele.flightNumber)),
        flightNumber:flightNumber
      };

      result.push(partMiles);
    }
  }


  // -----------------------------
  // STEP 3: SECOND PASS (ARRIVAL PART)
  // -----------------------------
  let final: MilestoneState[] = [...result];

  for (let i = 0; i < result.length; i++) {
    let cur: any = result[i];

    if (cur.isPart === true) {
      // const arrivalIndex = result.findIndex((e: MilestoneState) =>
      //   e.flights?.map((ele:any)=>ele.flightNumber).includes(cur.flightNumber) &&
      //   e.destination === cur.destination &&
      //   e.mileStone.toLowerCase().includes("arrival")
      // );
      let arrivalIndex = -1;
      for (let j = i; j < result.length; ++j) {
        let element: MilestoneState = result[j];
        let flights = element.flights?.map((ele: any) => ele.flightNumber) || [];

        if (flights.includes(cur.flightNumber) &&
          // element.destination === cur.destination &&
          element.mileStone.toLowerCase().includes("arrival")) {
          arrivalIndex = j;
          break;
        }

      }


      if (arrivalIndex !== -1&&result[arrivalIndex].status==0) {
        let arrivalEvent = result[arrivalIndex];

        let arrivalPart = {
          ...arrivalEvent,
          pieces: cur.totalPieces,
          weight: cur.totalWts,
          status: 0,
          date: "",
          estimatedDate: "",
          _id: "",
          isPart: true,
          isDetailAwaitedForPartShipment: true,

        };

        final[arrivalIndex] = arrivalPart; // **REPLACE**
      }
    }
  }

  // -----------------------------
  // STEP 4: RENUMBER SEQUENCES CLEANLY
  // -----------------------------
  let seqFinal = 1;
  final = final.map((x) => ({
    ...x,
    mileStoneSequence: seqFinal++,
    maxPkts: x.pieces,
    maxWeights: x.weight
  }));
  return final;

}



export function mapToOceanMilestoneState(data: MileStoneUpdateOfOceanState[], isOnline: boolean): MileStoneUpdateOfOceanState[] {


  let flateData = data;



  let mappedData = flateData.map((event: MileStoneUpdateOfOceanState, index: number) => ({
    _id: event._id,
    oceanTrackingNumber: event.oceanTrackingNumber,
    mileStone: event.mileStone,
    date: event.date,
    origin: event.origin,
    expectedDate: isOnline == true ? (event.status == 0 ? event.expectedDate : "") : (convertToInputDateFormat(event.status == 0 ? event.expectedDate : "")),
    destination: event.destination,
    portName: event.portName,
    status: event.status,
    vesselName: event?.vesselName,
    vesselId: event?.vesselId
  }));

 

  return mappedData;
}